import { PSMS_DIGITAL_SOLUTION_SUMMARY_FAILURE, PSMS_DIGITAL_SOLUTION_SUMMARY_LOADING, PSMS_DIGITAL_SOLUTION_SUMMARY_REQUEST, PSMS_DIGITAL_SOLUTION_SUMMARY_SUCCESS, PSMS_DS_ADOPTIONRATE_REQUEST } from "@src/middleware/actions/actionTypes";
import { getPSMSDigitalSolutionAdoptionRate, getPSMSDigitalSolutionSummary } from "@src/middleware/services/psms/DigitalAdoption.service";
import { put, takeLatest, call } from "redux-saga/effects";
import { getPSMSDigitalAdoptionRateLoading, getPSMSDigitalAdoptionRateSuccess, getPSMSDigitalDataSuccess, getPSMSDigitalLoading, getPSMSDigitalSummary  } from "@src/middleware/actions/psms/digitalAdoptionActions";
import get from 'lodash/get';

export function * fetchPSMSDigitalSolutionSummary(action: any) {
  const payload = action?.payload || {};
  yield put(getPSMSDigitalLoading(true));
  try {
    const response = yield call(getPSMSDigitalSolutionSummary, payload);
    yield put(getPSMSDigitalDataSuccess(response?.Data));
  } catch(error: any) {
     yield put(getPSMSDigitalSummary(error));
  } finally {
    yield put(getPSMSDigitalLoading(false));
  }
}

export function * fetchPSMSDigitalSolutionSummaryAdoptionRate(action: any) {
  const payload = action?.payload || {};
  yield put(getPSMSDigitalAdoptionRateLoading(true));
  try {
    const response = yield call(getPSMSDigitalSolutionAdoptionRate, payload);
    yield put(getPSMSDigitalAdoptionRateSuccess(response?.Data));
  } catch(error: any) {
     yield put(getPSMSDigitalAdoptionRateLoading(error));
  } finally {
    yield put(getPSMSDigitalAdoptionRateLoading(false));
  }
}


export function* digitalAdoptionSaga() {
  yield takeLatest(PSMS_DIGITAL_SOLUTION_SUMMARY_REQUEST, fetchPSMSDigitalSolutionSummary);
  yield takeLatest(PSMS_DS_ADOPTIONRATE_REQUEST, fetchPSMSDigitalSolutionSummaryAdoptionRate);
}
